import React from 'react';
import Recycle from '../../svgs/Recycle';
import Health from '../../svgs/Health';
import CostSaving from '../../svgs/CostSaving';

const Services = () => {
  return (
    <section id='services' className='services section-bg'>
      <div className='container' data-aos='fade-up'>
        <div className='section-title'>
          <h2>
            {' '}
            <span style={{ color: '#1a3f36' }}>Consume Less,</span> Fry Beyond
          </h2>
          <p>
            Companies who incorporate our product into their daily frying routine experience a wide range of benefits
          </p>
        </div>

        <div className='row d-flex justify-content-center'>
          <div className='col-xl-3 col-md-6 d-flex align-items-stretch' data-aos='zoom-in' data-aos-delay='100'>
            <div className='icon-box'>
              <div className='d-flex justify-content-center'>
                <div className='icon'>
                  <Recycle />
                </div>
              </div>
              <div className='d-flex justify-content-center'>
                <h4 style={{ color: '#55bb47' }}>Sustainability</h4>
              </div>
              <p style={{ textAlign: 'center' }}>
                By reducing the oil consumption and disposal, our products make your business more environmentally
                friendly and sustainable.
              </p>
            </div>
          </div>

          <div className='col-xl-3 col-md-6 d-flex align-items-stretch' data-aos='zoom-in' data-aos-delay='100'>
            <div className='icon-box'>
              <div className='d-flex justify-content-center'>
                <div className='icon'>
                  <Health />
                </div>
              </div>
              <div className='d-flex justify-content-center'>
                <h4 style={{ color: '#029ae7' }}>Healthier Food</h4>
              </div>
              <p style={{ textAlign: 'center' }}>
                Our products enable you to produce & serve healthier and more flavourful food, increasing customer
                satisfaction.
              </p>
            </div>
          </div>
          <div className='col-xl-3 col-md-6 d-flex align-items-stretch' data-aos='zoom-in' data-aos-delay='100'>
            <div className='icon-box'>
              <div className='d-flex justify-content-center'>
                <div className='icon'>
                  <CostSaving />
                </div>
              </div>
              <div className='d-flex justify-content-center'>
                <h4 style={{ color: '#fbba14' }}>Cost Savings</h4>
              </div>
              <p style={{ textAlign: 'center' }}>
                By safely extending the lifespan of frying oil, our products assist in reducing oil consumption and
                cost-cutting.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
